import DesignServicesTwoToneIcon from '@mui/icons-material/DesignServicesTwoTone';
import BrightnessLowTwoToneIcon from '@mui/icons-material/BrightnessLowTwoTone';
import MmsTwoToneIcon from '@mui/icons-material/MmsTwoTone';
import TableChartTwoToneIcon from '@mui/icons-material/TableChartTwoTone';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import BallotTwoToneIcon from '@mui/icons-material/BallotTwoTone';
import BusinessTwoToneIcon from '@mui/icons-material/BusinessTwoTone';
import BeachAccessTwoToneIcon from '@mui/icons-material/BeachAccessTwoTone';
import EmojiEventsTwoToneIcon from '@mui/icons-material/EmojiEventsTwoTone';
import FilterVintageTwoToneIcon from '@mui/icons-material/FilterVintageTwoTone';
import HowToVoteTwoToneIcon from '@mui/icons-material/HowToVoteTwoTone';
import LocalPharmacyTwoToneIcon from '@mui/icons-material/LocalPharmacyTwoTone';
import RedeemTwoToneIcon from '@mui/icons-material/RedeemTwoTone';
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import TrafficTwoToneIcon from '@mui/icons-material/TrafficTwoTone';
import VerifiedUserTwoToneIcon from '@mui/icons-material/VerifiedUserTwoTone';

const menuItems = [

  {
    heading: 'Dashboard',
    items: [
      {
        name: 'Users',
        link: '/dashboard/users',
        icon: AccountCircleTwoToneIcon
      },
      {
        name: 'Gripes',
        icon: MmsTwoToneIcon,
        link: '/dashboard/gripes'
      },
      {
        name: 'Categories',
        icon: BallotTwoToneIcon,
        link: '/dashboard/categories'
      },
      {
        name: 'Team',
        icon: BusinessTwoToneIcon,
        link: '/dashboard/team'
      },
    ]
  }
];

export default menuItems;
